import HyperLinkIcon from 'assets/ver2/icons/hyper-link-icon.svg';
import ButtonCommon from 'components/common/ButtonCommon';
import { DESKTOP_MIN_WIDTH } from 'constants';
import useFxAddTransaction from 'hooks/fx/useFxAddTransaction';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import styled from 'styled-components';
import { paragraphMixin } from 'styles';
import BodyHeader from './mobile/BodyHeader';

const BodySectionHeader = ({
  titleBodySection,
  titleSection,
  CalculatorComponent = null,
  onToggleCancelPopup = () => {},
  onViewPickupLocation = () => {},
  onViewOrderDetails = () => {},
  isDisabled,
}) => {
  const { t } = useLang();
  const { isMobile, isTablet } = useDetectDevice();

  const {
    addTransactionCurrentStep: currentStep,
    pickupLocationSelected,
    pickupLocationType,
    pickupDateSelected,
  } = useFxFormAddTransactionStore();
  const { isMakePayment, getPickupLocationName, orderRef } =
    useFxAddTransaction();

  const renderTitleCancelSection = () => {
    if (isMakePayment && (isMobile || isTablet))
      return (
        <>
          <TitleCancel>
            <TitleBodySection>{titleBodySection}</TitleBodySection>
            <ButtonCommon
              value={t('button_cancel')}
              color="var(--ds-c-blue-hyperlink-default)"
              background="var(--ds-c-white)"
              isFill={false}
              styles={{
                paddingInline: 0,
                fontWeight: 500,
                height: '29px',
              }}
              onClick={onToggleCancelPopup}
            />
          </TitleCancel>
          <RefText style={{ marginTop: '-14px' }}>
            <span>REF NO.</span> {`${orderRef}`}
          </RefText>
          <div style={{ marginBottom: '-20px' }}>
            {renderPickupLocationSection()}
          </div>
        </>
      );
    return (
      <TitleCancel>
        <TitleBodySection>{titleBodySection}</TitleBodySection>
        <ButtonCommon
          value={t('button_cancel')}
          color="var(--ds-c-blue-hyperlink-default)"
          background="var(--ds-c-white)"
          isFill={false}
          styles={{
            paddingInline: 0,
            fontWeight: 500,
            height: '29px',
          }}
          onClick={onToggleCancelPopup}
        />
      </TitleCancel>
    );
  };
  const renderCalculatorSection = () => {
    if (isEmpty(CalculatorComponent)) return null;
    return CalculatorComponent;
  };
  const renderPickupLocationSection = () => {
    if (currentStep < 2) return null;
    if (isMakePayment)
      return (
        <PickupLocationAndDate>
          <PickupItem>
            <ButtonCommon
              value={t('button_view_order_details')}
              onClick={onViewOrderDetails}
              styles={{
                padding: '0px',
                fontWeight: 500,
              }}
              color="var(--ds-c-blue-hyperlink-default)"
              background="transparent"
              isFill={false}
              iconSrc={HyperLinkIcon}
              iconStyles={{
                padding: '1px',
              }}
              buttonIconStyles={{
                margin: '0px',
                marginLeft: '0px',
                padding: '0px',
                width: 'fit-content',
                height: '20px',
                gap: '4px',
              }}
            />
          </PickupItem>
        </PickupLocationAndDate>
      );
    return (
      <PickupLocationAndDate>
        <PickupItem>
          <p>
            <b>{t('label_pickup_at')}:</b>
            {getPickupLocationName(pickupLocationSelected, pickupLocationType)}
          </p>
          <ButtonCommon
            value={t('button_view')}
            onClick={onViewPickupLocation}
            styles={{
              margin: '0px',
              marginLeft: '4px',
              padding: '0px',
              width: 'fit-content',
              height: '20px',
              fontWeight: 500,
            }}
            color="var(--ds-c-green-default)"
            background="transparent"
            isFill={false}
          />
        </PickupItem>
        {!isEmpty(pickupDateSelected) && (
          <PickupItem>
            <p>
              <b>{t('label_pickup_on')}:</b>
              {pickupDateSelected}
            </p>
          </PickupItem>
        )}
      </PickupLocationAndDate>
    );
  };
  const renderBodyHeader = () => {
    if (isMobile || isTablet) {
      return (
        <BodyHeader
          titleSection={titleSection}
          renderTitleCancelSection={renderTitleCancelSection}
          isDisabled={isDisabled}
        />
      );
    }
    return (
      <TitleProcessStepsSection>
        {renderTitleCancelSection()}
        {renderCalculatorSection()}
        {renderPickupLocationSection()}
        <TitleSection>{titleSection}</TitleSection>
      </TitleProcessStepsSection>
    );
  };

  return <>{renderBodyHeader()}</>;
};

const TitleProcessStepsSection = styled.div``;
const TitleBodySection = styled.h2`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ds-c-blue-disabled);
  margin-bottom: 0px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    font-size: 16px;
    line-height: 20px;
    color: var(--ds-c-grey-dark);
  }
`;
const TitleCancel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    margin-bottom: 24px;
  }
`;
const TitleSection = styled.h1`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-transform: uppercase;
  color: var(--ds-c-green-default);
  padding-block: 8px;
  margin-bottom: 20px;
  height: 36px;
  border-bottom: 1px solid var(--ds-c-blue-remox-light);
`;
const PickupLocationAndDate = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;
const PickupItem = styled.div`
  display: flex;

  & p {
    ${paragraphMixin};
    font-weight: 500;

    & b {
      margin-right: 4px;
    }
  }
`;

const RefText = styled.p`
  font-family: var(--ff-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: var(--ds-c-blue-hyperlink-default);
  text-align: left;

  margin: 0;
  padding: 0;
  margin-bottom: 10px;

  & span {
    font-family: var(--ff-primary);
    font-weight: 600;
    color: var(--ds-c-black);
  }
`;

export default BodySectionHeader;
